import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';

import { FormHelper } from '../../helpers/form-helper';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	private key: string;

  constructor(private authService: AuthService,
							private dialogRef: MdDialogRef<UserProfileComponent>,
							private formBuilder: FormBuilder,
							private userService: UserService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();

		this.getUser();
	}

  ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public getUser(): void {
		this.subscriptionManager.add(this.userService.getUser(this.authService.getUID()).subscribe(next => {
			this.updateForm(next);
		}))
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			name: new FormControl('', Validators.required),
			lastname: new FormControl('', Validators.required),
			email: new FormControl('', [Validators.required, Validators.email])
		});
	}

	public updateForm(user: User): void {
		this.key = user.$key;

		this.form.controls['name'].setValue(user.name);
		this.form.controls['lastname'].setValue(user.lastname);
		this.form.controls['email'].setValue(user.email);
	}

	public submitForm(): void {
		let user: User = this.form.value;

		this.userService.updateUser(this.key, user);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/user-profile/user-profile.component.ts